export const vatIdLengthData = {
  GB: 9,
  FR: 11,
  DE: 9,
  AU: 11,
  CA: 15,
  CA_MB: 7,
  CA_BC: 8,
  CA_QC: 10,
  CA_SK: 7
};
